import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
export function CoverageSection() {
  const countries = [{
    name: 'Argentina',
    flagUrl: 'https://cdn.magicpatterns.com/uploads/t8NU7D3hHxenffuVgZqfBe/Bandera_Argentina.png',
    status: 'active' as const,
    url: 'https://zumpago.com.ar/'
  }, {
    name: 'Chile',
    flagUrl: 'https://cdn.magicpatterns.com/uploads/3M3DrXQ99UvFpnhNCdYSeE/Bandera_Chilena.png',
    status: 'active' as const,
    url: 'https://www.zumpago.cl/'
  }, {
    name: 'Ecuador',
    flagUrl: 'https://cdn.magicpatterns.com/uploads/8Y9gMYnHYm9JRCEbr4D1Je/Bandera_Ecuatoriana.png',
    status: 'active' as const,
    url: 'https://zumpago.ec/'
  }, {
    name: 'Perú',
    flagUrl: 'https://cdn.magicpatterns.com/uploads/fwo5GYCbkvzP3iyAg4UkYQ/Bandera_Peruana.png',
    status: 'coming' as const,
    url: undefined
  }];
  return <section id="cobertura" className="py-24 bg-white" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-69">
          <h2 className="text-lg font-bold text-zumpago-red tracking-wider uppercase mb-3" data-id="element-70">
            Cobertura Regional
          </h2>
          <h3 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-71">
            Conectando a toda Latinoamérica
          </h3>
          <p className="text-lg text-gray-600" data-id="element-72">
            Nuestra red de procesamiento se expande continuamente para ofrecerte
            soluciones de pago locales en los mercados más importantes de la
            región.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto" data-id="element-73">
          {countries.map((country, index) => {
          const isActive = country.status === 'active';
          const hasLink = isActive && country.url;
          const CardContent = <motion.div key={country.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`relative rounded-3xl overflow-hidden flex flex-col items-center text-center transition-all ${isActive ? 'bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:border-zumpago-red/40 hover:-translate-y-1' : 'bg-gray-50 border-2 border-dashed border-gray-200'}`} data-id="element-74">
                {/* Flag image taking most of the card */}
                <div className="w-full aspect-[3/2] overflow-hidden" data-id="element-75">
                  <img src={country.flagUrl} alt={`Bandera de ${country.name}`} className="w-full h-full object-cover" data-id="element-76" />
                </div>

                {/* Country name and status */}
                <div className="p-5 w-full" data-id="element-77">
                  <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-78">
                    {country.name}
                  </h4>

                  {!isActive && <span className="text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider bg-gray-200 text-gray-500" data-id="element-79">
                      Próximamente
                    </span>}

                  {hasLink && <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-zumpago-red" data-id="element-80">
                      Visitar sitio <ExternalLink className="w-4 h-4" data-id="element-81" />
                    </span>}
                </div>
              </motion.div>;
          if (hasLink) {
            return <a key={country.name} href={country.url} target="_blank" rel="noopener noreferrer" className="block" data-id="element-82">
                  {CardContent}
                </a>;
          }
          return <div key={country.name} data-id="element-83">{CardContent}</div>;
        })}
        </div>
      </div>
    </section>;
}